<template>
    <div>
        <v-dialog
            v-model="display"
            width="350"
            persistent>
            <v-card flat>
                <v-card-title>
                    {{ $t('print') }}
                    <v-spacer></v-spacer>
                </v-card-title>
                <!-- <div class="text-center" v-if="loading.data">
                    <v-progress-circular
                        indeterminate>
                    </v-progress-circular>
                </div> -->
                <v-card-text>
                    {{ $t('print_msg_account') }}
                    <div id="accountStatement" style="display: none"  >
                        <div>
                            <div class="row">
                                <div class="col-sm">
                                   <div>
                                        <h4 class="text-left">Petra Ready Mixed Concrete</h4>
                                        <h4 class="text-left"><b>Accounting Department</b></h4>
                                        <h4 class="text-left">{{ $t('account_statement') }}</h4>
                                    </div>
                                </div>
                                <!-- <div class="col-sm">
                                    <img style="float: right;" class="text-right"  width="150" src="../../assets/petralogo.png" alt="">
                                </div> -->
                            </div>
                            <br>
                            <div class="row">
                                <div class="col-sm">
                                    <div class="text-left">
                                        <h4 v-if="form.account">{{ $t('account') }}: {{ form.account }}</h4>
                                        <h4>{{ $t('date') }}: {{ form.from }} {{ $t('to') }}  {{ form.to }}</h4>
                                    </div>
                                </div>
                            </div>
                            <hr>
                            <br>
                            <br>
                            <div class="row">
                                <div class="col-sm">
                                    <!-- <h5 class="text-left">{{ $t('delivery_status_report') }} :</h5> -->
                                    <table style="border-collapse: collapse; border: none;" class="table table-bordered table-sm">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th style="align-content: center;">{{ this.$t('date') }}</th>
                                                <th style="align-content: center;" width="150px">{{ this.$t('reference_no') }}</th>
                                                <th style="align-content: center;">{{ this.$t('reference_type') }}</th>
                                                <th style="align-content: center;">{{ this.$t("description") }}</th>
                                                <th style="align-content: center;">{{ this.$t('debit') }}</th>
                                                <th style="align-content: center;">{{ this.$t('credit') }}</th>
                                                <th style="align-content: center;">{{ this.$t('balance') }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(statement, index) in accountStatements" :key="index">
                                                <td>{{ index + 1 }}</td>
                                                <td width="100px"> {{ statement.transaction_date }} </td>
                                                <td> {{ statement.reference_code }} </td>
                                                <td width="150px"> {{ statement.transaction_type }} </td>
                                                <td :style="isArabic(statement.narration) ? 'text-align: right;': ''" style="align-content: right;"> {{ statement.narration }} </td>
                                                <td>{{ renderDebit(statement.amount, statement.base_amount) }} </td>
                                                <td>{{ renderCredit(statement.amount, statement.base_amount) }} </td>
                                                <td width="150px"> {{ renderBalance(statement.balance, statement.base_balance) }} </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="print" text>
                        {{ $t('print') }}
                    </v-btn>
                    <v-btn @click="close" text>
                        {{ $t('close_btn') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import {formatMoney} from 'accounting';
import isArabic from '@/utils/isArabic';

export default {
    name: "AccountStatementPrintDialog",
    components: {},
    props: {
        accountStatements: {
            type: Array,
            required: true
        },
        form: {
            type: Object,
            required: true
        },
        baseCurrency: String,
        accountCurrency: String,
        inAccountCurrency: Boolean
    },
    data() {
        return {
            display: true,
        }
    },
    computed: {
        currency() {
            return this.inAccountCurrency ? this.accountCurrency : this.baseCurrency;
        }
    },
    methods: {
        formatMoney,
        isArabic,
        formatCurrency(amount) {
            return formatMoney(amount, this.currency, 2);
        },
        print() {
            this.$htmlToPaper("accountStatement");
            this.close();
        },
        isPositive(amount) {
            return amount > 0;
        },
        isNegative(amount) {
            return amount < 0;
        },
        renderDebit(amount, base_amount) {
            let selected = this.inAccountCurrency ? amount : base_amount;
            return this.isPositive(selected) ? this.formatCurrency(Math.abs(selected)) : null;
        },
        renderCredit(amount, base_amount) {
            let selected = this.inAccountCurrency ? amount : base_amount;
            return this.isNegative(selected) ? this.formatCurrency(Math.abs(selected)) : null;
        },
        renderBalance(balance, base_balance) {
            let selected = this.inAccountCurrency ? balance : base_balance;
            return this.formatCurrency(selected);
        },
        close() {
           this.$emit('close');
        }
       
    },
}
</script>